import React from 'react'
import { Modal, Button, Header, Divider } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
var moment = require('moment');
class CopyActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false
        }
      }
    handleClose = () => {
        dispatch.initiatives.setCopyActivityModalOpen(false);
        dispatch.initiatives.copyActivityModalOpen(false);
    }
    handleCopy=()=>{
        let selectedActivity = this.props.selectedActivityData;
        dispatch.initiatives.copyActivity(selectedActivity);
        dispatch.initiatives.copyActivityModalOpen(false);
        this.setState({showLoader:true})
    }
    render() {
        let ActivityNode = this.props.ActivityNode;
        return (
            <Modal
                className="basicModal"
                open={this.props.isCopyActivityModalOpen}
                style={{ width: "600px" }}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header> 
                    <span style={{color: '#3EA2F7'}}>{`Copy ${ActivityNode} : ${this.props.selectedActivityData.name}`}</span>
                </Modal.Header>
                <Divider/>
                <Modal.Content style={{paddingTop: '0px'}}>
                    <strong>
                        {this.props.infoStatement1 ? this.props.infoStatement1 : '' }<br/><br/>
                    </strong>
                    <p>
                    {this.props.infoStatement2 ? this.props.infoStatement2 : '' }<br/>
                    <div style={{backgroundColor:'#e1f4fa'}}>{`${this.props.selectedActivityData && this.props.selectedActivityData.parentActivity ? this.props.selectedActivityData.parentActivity.name : ''}`}</div><br/><br/>
                    <strong >
                        * Note<br/>
                    </strong>
                    
                    <span style={{color: '#AAAAAA'}}>What will get copied from original activity?</span><br/>
                    Name, description, milestone, duration, references, attachments and RACI<br/><br/>

                    <span style={{color: '#AAAAAA'}}>What will not get copied from original activity?</span><br/>
                    Comment and dependencies. You can set dependencies later on.
                    </p>
                </Modal.Content>
                <Modal.Actions>
                <Button
                    className="button-submit float-right"
                    id='addbtn'
                    onClick={this.handleCopy}
                    type="submit"> Confirm
                </Button>
                <Button
                    id='cancelBtn'
                    className="button-cancel"
                    onClick={this.handleClose}
                    type="button"> Cancel
                </Button>

                </Modal.Actions>
            </Modal>
        )
    }
}
export default CopyActivity;